
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-freight-procurement-software",
      function () {
        return require("private-next-pages/content/what-is-freight-procurement-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-freight-procurement-software"])
      });
    }
  